import { Store, SerializedData } from "bernie-core";
import { observable, action } from "mobx";
import { Logger, NOOP_LOGGER } from "bernie-logger";
import { AdsTarget } from "components/flexComponents/Ad/typings";

export class AdvertisingStore extends Store {
  public constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  @observable
  public adsloader: string;
  @observable
  public adsloaderFallback: string;
  @observable
  public includeAdLoader: boolean;
  @observable
  public adsSuppressed: boolean;
  @observable
  public CMPTST: string;
  @observable
  public adSlotIdOverride: string;
  @observable
  public adBlockDetect: string;
  @observable
  public adBlockerEnabled?: boolean;
  @observable
  public adsTarget?: AdsTarget;

  private disableFramework: boolean;

  public static DEFAULTS = {
    adsloader: "",
    adsloaderFallback: "",
    includeAdLoader: false,
    adsSuppressed: false,
    disableFramework: false,
    CMPTST: "",
    adSlotIdOverride: "",
    adBlockDetect: "",
  };

  @action
  private suppressAds(scope: string) {
    scope = scope.toUpperCase();

    if (scope === "FRAMEWORK") {
      this.disableFramework = true;
      this.adsSuppressed = true;
      this.includeAdLoader = false;
    } else if (scope === "SPOTS") {
      this.adsSuppressed = true;
    }
  }

  @action
  private overrideTargeting(targetingKey: string) {
    this.CMPTST = targetingKey;
  }

  @action
  private overrideSlotId(slotId: string) {
    this.adSlotIdOverride = slotId;
  }

  @action
  public includeAd() {
    if (!this.disableFramework) {
      this.includeAdLoader = true;
    }
  }

  @action
  public updateTarget(target: AdsTarget) {
    this.adsTarget = target;
  }

  @action
  public overrideWithQueryParams(queryParams: { [key: string]: string }) {
    if (queryParams.suppressAds) {
      this.suppressAds(queryParams.suppressAds.toUpperCase());
    }

    if (queryParams.adTargetingOverride) {
      this.overrideTargeting(queryParams.adTargetingOverride);
    }

    if (queryParams.adSlotIdOverride) {
      this.overrideSlotId(queryParams.adSlotIdOverride);
    }
  }

  /**
   * Checks if the passed target has changed since the last time it was set to the advertising store.
   *
   * @param newTarget
   */
  public hasTargetChanged(newTarget: AdsTarget): boolean {
    if (!this.adsTarget && !newTarget) {
      return false;
    }
    if ((!this.adsTarget && newTarget) || (this.adsTarget && !newTarget)) {
      return true;
    }
    const targetUnchanged =
      this.adsTarget &&
      this.adsTarget.siteId === newTarget.siteId &&
      this.adsTarget.pageId === newTarget.pageId &&
      this.adsTarget.locale === newTarget.locale &&
      this.adsTarget.variant === newTarget.variant &&
      this.adsTarget.brand === newTarget.brand &&
      this.adsTarget.canTrack === newTarget.canTrack &&
      this.adsTarget.canSell === newTarget.canSell;

    return !targetUnchanged;
  }
}
